import React from 'react';
import {Mail} from "lucide-react";
const Contact = ({ theme }) => {
    const textColor = theme === 'tech' ? 'text-green-400' : 'text-blue-500';

    return <div className="max-w-4xl mx-auto px-4 py-8">
        <h1 className="text-3xl font-bold mb-8">Contact Us</h1>
        <div className="grid md:grid-cols-2 gap-8 mb-12">
            <div className="space-y-4">
                <p className="text-lg">
                    <a href="mailto:info@songerconsulting.se"
                       className={`flex items-center gap-2 ${textColor} hover:opacity-80 transition-opacity`}>
                    <Mail size={18}/>
                    <span>info@songerconsulting.se</span>
                </a></p>
                <p className="text-lg">Phone: +46 73 920 24 90</p>
                <p className="text-lg">Address: Stora gatan 1B, Västerås, Sweden</p>
                <p className="text-lg">VAT: SE559500234501</p>
            </div>
            <div>
                <p className="text-lg mb-4">
                    Feel free to reach out to us using any of our contact channels.
                    We look forward to hearing from you!
                </p>
            </div>
        </div>
        {
            //<ContactForm theme={theme}/>
        }
    </div>
}
export default Contact;